import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "./style.css";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "Assets/loginLogo.svg";
import { saveKey } from "utils/Helper";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import axios from "axios";
import { origin } from "utils/Helper";
//import {
//  environment,
//  HeaderConfig
//} from "Api/Api";
//import { apiUrl, myHeaders_Autorized, HeaderConfig, location_api, myHeaders_With_Cache_Control,search_Presentation_API } from "Api/Api";
import { myHeaders_Authorized, apiUrl, myHeaders_Auth_With_Cache_Control, location_search, User_Patch_Api, user_entity_uuid } from "Api/Api";
// , HeaderConfig
import geoLocation from 'utils/geoLocation';
import { local_routes } from 'utils/Routes';

//const locationSearchAPI = environment.location_Search;
//const User_Patch_Api = environment.User_Patch_Api;

class AboutYourself extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_info: {},
      message: "",
      error_message: "",
      loading: true,
      value: "",
      name: '',
      loading: true,
      city: null,
      validated: false,
      ModalLoader: false,
      city_Data: [],
      city_country: ''
    };
  }

  /*
  findMyLocation = async (cityData) => {
      console.log("findMyLocation");
      if (!cityData) {
        cityData = this.state.cityData;
      }
      try {
          let geo_data = await geoLocation(); // ask browser for location
          console.log(geo_data);
          // we got user's lat/lon from browser
          let latitude = geo_data.latitude;
          let longitude = geo_data.longitude;
      
          let closest_location_res = await axios.get(`${locationSearchAPI}?coordinates_lat=${latitude}&coordinates_lon=${longitude}&radius=20038&limit=1`, HeaderConfig);
          let closest_location = closest_location_res.data.search_query_results[0].entity_info;
          console.log(closest_location);

          let tmp_city_arr = [];
          if (closest_location.country && closest_location.city_name) {
              let closest_city_country = closest_location.city_name+', '+closest_location.country;
              this.
              cityData.forEach((item) => {
                  if (closest_city_country === item.city_country) {
                      tmp_city_arr.push(item.city_name);
                  }
              })
              this.setState({ country: closest_location.country, cityArr: tmp_city_arr.unique().sort(), city: closest_location.city_name });
              //this.setState({country:closest_location.country,city:closest_location.city_name});
          }

      } catch (err) {
        // we did not get user's lat/lon from browser - that is ok
      }
  }
  */
  
  async componentDidMount() {
    if (!user_entity_uuid) {
      // redirect to login
      console.error("AboutYourself not logged in, redirecting to /login");
      this.props.history.push(local_routes.login);
      return;
    }
    
    let new_state = {...this.state};
    
    document.body.style.background = "#343E47";
    let tempArr = [];
    let latitude = 0;
    let longitude = 0;
    try {
      let geo_data = await geoLocation(); // ask browser for location
      console.log("Got browser geo_data",geo_data);
      latitude = geo_data.latitude;
      longitude = geo_data.longitude;
    } catch (err) {
      // we did not get user's lat/lon from browser - that is ok
      console.log("Did NOT get browser geo_data :(");
    }
    
    let [users_response, locations_response] = await Promise.all([
      axios.get(`${apiUrl}users/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control),
      axios.get(`${location_search}?coordinates_lat=${latitude}&coordinates_lon=${longitude}&radius=20038`)
    ]);
    
    new_state.user_info = users_response.data;
    
    let tmp_nickname_array = [];
    if (new_state.user_info.firstname) {
      tmp_nickname_array.push(new_state.user_info.firstname);
    }
    if (new_state.user_info.lastname) {
      tmp_nickname_array.push(new_state.user_info.lastname);
    }
    new_state.user_info.nickname = tmp_nickname_array.join(' ');
    new_state.name = tmp_nickname_array.join(' ');
    
    let minified_res = locations_response.data.search_query_results;
    minified_res.forEach(function(element) {
      element.entity_info.city_country = element.entity_info.city_name.trim()+', '+element.entity_info.country;
      tempArr.push(element.entity_info);
    });
    let closest_city_country = tempArr[0].city_country;
    console.log("closest_city_country",closest_city_country);
    tempArr = tempArr.sort((a, b) =>
      a.city_name.localeCompare(b.city_name, "es", { sensitivity: "base" })
    );
    //this.setState({ city_Data: tempArr, loading: false });
    
    // if we got browser lat/lon, select first result from locationsearch as the selected city
    if (latitude || longitude) {
      new_state.city_country = closest_city_country;
    } else {
      new_state.city_country = tempArr[0].city_country;
    }
    
    new_state.city_Data = tempArr;
    new_state.loading = false;
    
    this.setState(new_state);
    
    /*
    if (latitude || longitude) {
      this.setState({ 
        city_country: closest_city_country,
        city_Data: tempArr,
        loading: false
      });
    } else {
      this.setState({
        city_country: tempArr[0].city_country,
        city_Data: tempArr,
        loading: false
      });
    }
    */

  }

  myChangeHandler = event => {
    if (event.target.id === "validationName") {
      this.setState({ name: event.target.value });
    } else if (event.target.id === "validationCity") {
      this.setState({ city_country: event.target.value });
    }
  };

  handleSubmitData = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity() !== false) {
      this.setState({ ModalLoader: true });
      let firstName, lastName;
      let cityTempArr = [];
      let CityArr = [];
      event.preventDefault();
      const { name, city_country } = this.state;
      saveKey("First_Time_Status", 1);
      firstName = name
        .split(" ")
        .slice(0, -1)
        .join(" ");
      lastName = name
        .split(" ")
        .slice(-1)
        .join(" ");
      this.state.city_Data.forEach(function(item) {
        if (item.city_country === city_country) {
          cityTempArr.push(item);
        }
      });
      CityArr = [
        {
          xref_data: { resident_integer: 1 },
          entity_uuid: cityTempArr[0].entity_uuid
        }
      ];


      let patch_obj = {
        firstname: firstName,
        lastname: lastName,
        //friendly_url: friendly_url_conv,
        "locations.audience": CityArr
      };
      
      if (!this.state.user_info.nickname) {
        let friendly_url = `${firstName} ${lastName}`;
        let friendly_url_conv = friendly_url.toLowerCase().replace(/ /g, "-");
        patch_obj.friendly_url = friendly_url_conv;
      }

        try {
          await axios.patch(`${User_Patch_Api}/${user_entity_uuid}`,patch_obj,myHeaders_Authorized);
          this.setState({ ModalLoader: false });
          window.location.href = origin;
        } catch (err) {
          console.error("ERROR",err);
          this.setState({ ModalLoader: false });
        }        

    /*
      if (
        this.props.location.state !== null &&
        this.props.location.state !== undefined
      ) {

        var myHeaders_Autorized = {
          headers: {
            "x-api-key": process.env.REACT_APP_PK_API_KEY,
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.props.location.state.accessToken.access_token}`
          }
        };
        
        axios
          .patch(
            //`${User_Patch_Api}/${this.props.location.state.accessToken.user_uuid}`,
            `${User_Patch_Api}/${user_entity_uuid}`,
            JSON.stringify(YourInfo),
            //myHeaders_Autorized
            myHeaders_Authorized
          )
          .then(() => {
            this.setState({ ModalLoader: false });
            window.location.href = origin;
          })
          .catch(() => {
            this.setState({ ModalLoader: false });
          });
          
      } else {
        this.props.history.push("/register");
      }
      */
    }
    this.setState({ validated: true });
  };

  render() {
    const { ModalLoader } = this.state;
    if (this.state.loading) {
      return <ActivityIndicator theme="spinnerbgBlack" />;
    } else {
      return (
        <React.Fragment>
        <Helmet>
          <title>PechaKucha About Yourself</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="Login-grid">
          <Row className="nomargin">
            <Col lg={12}>
              <div className="flex-center logo-container">
                <a href="/">
                  <img
                    src={logo}
                    alt="img"
                    className="img-fluid navbar-brand img-logo"
                  />
                </a>
              </div>
              <div className="Login-Form">
                <div className="Login-body">
                  <p>Welcome to PechaKucha! Please tell us a little about yourself</p>
                  <div className="Form-section">
                    <Form
                      noValidate
                      validated={this.state.validated}
                      onSubmit={this.handleSubmitData}
                    >
                      <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationName">
                          <Form.Label>NAME</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter your Name"
                            value={this.state.name}
                            onChange={this.myChangeHandler}
                          />
                        </Form.Group>
                      </Form.Row>

                      <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationCity">
                          <div className="city-Dropdown dropdownLableCity">
                            <Form.Label>PICK YOUR CITY</Form.Label>
                            <Form.Control
                              as="select"
                              required
                              value={this.state.city_country}
                              onChange={this.myChangeHandler}
                            >
                              {this.state.city_Data.map(item => (
                                <option key={item.entity_uuid}>{item.city_country}</option>
                              ))}
                            </Form.Control>
                          </div>
                        </Form.Group>
                      </Form.Row>

                      <h6>
                        Your name is public. We'll use your email address to
                        send you updates, and your location for PKs and events
                        near you.
                      </h6>
                      {ModalLoader === false ? (
                        <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5">
                          Continue
                        </Button>
                      ) : (
                        <ActivityIndicator theme="button-Status-Loader" />
                      )}
                      <p>
                        When you "Continue", you agree to PechaKucha’s Terms of
                        Service. We will manage information about you as
                        described in our Privacy Policy and Cookie Policy.
                      </p>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        </React.Fragment>
      );
    }
  }
}

export default AboutYourself;
